import { Button } from '@today/ui-primitives'
import type { ReactElement, ReactNode } from 'react'
import type { Translate } from './content-types'

/**
 * Props for {@link TenantDefaultsView}.
 *
 * @property list - The tenant assignments (an {@link AssignmentListView}).
 * @property onAttach - Present only with `content.assign`.
 */
export interface TenantDefaultsViewProps {
	t: Translate
	list: ReactNode
	onAttach?: () => void
}

/** The tenant defaults panel: texts shown at the end of every offer (organism). */
export function TenantDefaultsView(props: TenantDefaultsViewProps): ReactElement {
	const { t } = props
	return (
		<section className="flex flex-col gap-4">
			<header className="flex items-center justify-between">
				<div>
					<h1 className="text-ds-xl font-semibold text-ds-text">{t('tenantDefaults.title')}</h1>
					<p className="text-ds-sm text-ds-text-muted">{t('tenantDefaults.hint')}</p>
				</div>
				{props.onAttach ? <Button onPress={props.onAttach}>{t('assignments.attach')}</Button> : null}
			</header>
			{props.list}
		</section>
	)
}
